export default {
  setFilters(state, payload) {
    state.filters = payload;
  },
  setSearchMethod(state, payload) {
    state.searchMethod = payload;
  },
  setPsls(state, payload) {
    state.psls = payload || [];
  },
  setPslsCount(state, payload) {
    state.pslsCount = payload;
  },
  toggleLoading(state, isLoading) {
    state.loading = isLoading;
  },
  setPagination(state, payload) {
    state.pagination = payload;
  },
  setVolumesToSend(state, payload) {
    state.volumesToSend = payload;
  },
  setSendPslLoading(state, payload) {
    state.sendPslLoading = payload;
  },
  setAllVolumesSelected(state, payload) {
    state.AllVolumesSelected = payload;
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-psl/features/list/store/mutations.js